































































































import Vue from 'vue'
import AccessDateRows from './AccessDateRows.vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { RezitoreAdminAPI } from '@/provider/api'
import LinearLoading from '@/components/Loading/LinearLoading.vue'
const moment = require('moment')

@Component({
  components: {
    AccessDateRows,
    LinearLoading
  }
})
export default class Access extends Vue {
  loading: boolean = true
  randomizeDate: Date = new Date()
  userId: string = ''
  api: RezitoreAdminAPI = new RezitoreAdminAPI()
  selectedDate: Date = new Date()
  menu: boolean = false
  datePickerDateString: string = ''
  sunDate: Date = this.dateWeekStart(this.selectedDate)
  dataSun: Array<any> = [];
  dataMon: Array<any> = [];
  dataTue: Array<any> = [];
  dataWed: Array<any> = [];
  dataThu: Array<any> = [];
  dataFri: Array<any> = [];
  dataSat: Array<any> = [];

  @Watch('datePickerDateString')
  onDatePickerDateStringChanged () {
    this.selectedDate = new Date(this.datePickerDateString)
  }

  @Watch('selectedDate')
  async updateUserListView () {
    this.datePickerDateString = this.selectedDate.toISOString().substr(0, 10)
    this.sunDate = this.dateWeekStart(this.selectedDate)
    this.openAccessLog(this.selectedDate)
  }

  async beforeMount () {
    this.userId = this.$route.params.userId
    let baseDate = new Date()
    this.openAccessLog(baseDate)
  }

  // 指定した日が含まれる週の日曜日のDateを返す
  dateWeekStart (includedDate: Date) {
    let startDate = new Date(includedDate)
    startDate.setDate(startDate.getDate() - includedDate.getDay())
    return startDate
  }

  async openAccessLog (includedDate: Date) {
    this.loading = true
    let startDate = this.dateWeekStart(includedDate)
    let data = JSON.parse(await this.api.getUserAccessTime(this.userId, startDate.toISOString()))
    console.log('data stored:', data)
    this.randomizeDate = new Date(data.assignedAt)
    this.setData(data.access, startDate)
    this.loading = false
  }

  setData (data: Array<AccessTime>, baseDate: Date) {
    let result:Array<Array<AccessTime>> = []
    for (let i = 0; i < 7; i++) {
      result[i] = []
    }
    console.log(data)
    for (let i in data) {
      let dateDiff = new Date(data[i].to).getDay() - baseDate.getDay()
      result[dateDiff].push(data[i])
    }
    this.dataSun = result[0]
    this.dataMon = result[1]
    this.dataTue = result[2]
    this.dataWed = result[3]
    this.dataThu = result[4]
    this.dataFri = result[5]
    this.dataSat = result[6]
  }

  addSelectedDate (value: number) {
    console.log('substruct:', value, this.selectedDate)
    let newDate = new Date(this.selectedDate)
    newDate.setDate(newDate.getDate() + value)
    this.selectedDate = newDate
    console.log('result:', this.selectedDate)
  }
}

interface AccessTime {
  to: string,
  from: string
}
